import { render, staticRenderFns } from "./ProfileBasic.vue?vue&type=template&id=2ba1520a"
import script from "./ProfileBasic.vue?vue&type=script&lang=js"
export * from "./ProfileBasic.vue?vue&type=script&lang=js"
import style0 from "./ProfileBasic.vue?vue&type=style&index=0&id=2ba1520a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ProfileBasic.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports